// Categories (CAT clusters) — persisted in localStorage
// Per Creative Naming Convention v2 (2026-06) — CAT is the primary testing axis.
// Values go into export filenames -> must stay slug-safe (lowercase, no space/underscore).
const LS_KEY = 'timbo_categories_v1';

const DEFAULT_CATEGORIES = [
  'fashion',
  'beauty',
  'food',
  'home',
  'other',
];

export function getCategories() {
  try {
    const saved = JSON.parse(localStorage.getItem(LS_KEY));
    return saved && saved.length ? saved : [...DEFAULT_CATEGORIES];
  } catch { return [...DEFAULT_CATEGORIES]; }
}

export function saveCategories(list) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch {}
}

export function resetCategories() {
  try { localStorage.removeItem(LS_KEY); } catch {}
}

// lowercase, strip anything that isn't a-z0-9- so a CAT value never breaks a name block
export function sanitizeCategory(v) {
  return (v || '').trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
}

export default DEFAULT_CATEGORIES;
